import { gsap } from '../animations';

/**
 * Block "Statistiche": ogni numero conta da 0 al valore quando entra nel
 * viewport. Il markup contiene già il valore finale (resa statica): qui lo
 * riportiamo a 0 e animiamo solo se il movimento è consentito.
 */
export function initStatistiche() {
	// Con reduced-motion lasciamo la resa statica (valore finale già visibile).
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	const els = document.querySelectorAll( '[data-count-up]' );

	els.forEach( ( el ) => {
		const target = parseFloat( el.dataset.target );
		if ( Number.isNaN( target ) ) {
			return;
		}

		const decimals = parseInt( el.dataset.decimals || '0', 10 );
		const thousand = 'thousand' === el.dataset.format;
		const obj      = { v: 0 };

		const renderValue = () =>
			thousand
				? String( Math.round( obj.v ) ).replace( /\B(?=(\d{3})+(?!\d))/g, '.' )
				: obj.v.toFixed( decimals );

		el.textContent = renderValue();

		gsap.to( obj, {
			v: target,
			duration: 1.6,
			ease: 'power2.out',
			scrollTrigger: { trigger: el, start: 'top 88%', once: true },
			onUpdate: () => {
				el.textContent = renderValue();
			},
		} );
	} );
}
